import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { MsalAccountService } from '../services/msal-account/msal-account.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private _msalAccountService: MsalAccountService
  ) { }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const account = this._msalAccountService.getAccountInfo();
    const accountRoles =  account?.idTokenClaims?.roles || [];
    const route = next.routeConfig;
    const allowedRoutes = this._msalAccountService.allowedUrlsByRoles(accountRoles);
    return allowedRoutes.map(route => route).includes(route);
  }
}